import { sanityDataset, sanityProjectId } from '@/lib/env';

// Docs: https://nextjs.org/docs/pages/api-reference/components/image#loaderfile https://nextjs.org/docs/pages/api-reference/components/image#loaderfile
export default function sanityLoader({
  src,
  width,
  quality
}: {
  src: string;
  width: number;
  quality?: number;
}) {
  const maxWidthMatch = src.match(/-(\d+)x\d+-/);
  const maxWidth = maxWidthMatch && maxWidthMatch[1] ? parseInt(maxWidthMatch[1], 10) : null;
  const formattedSrc = src.replace(/^image-/, '').replace(/-(?=[^-]*$)/, '.');
  const url = new URL(
    `https://cdn.sanity.io/images/${sanityProjectId}/${sanityDataset}/${formattedSrc}`
  );
  url.searchParams.set('fm', 'webp');
  url.searchParams.set('auto', 'format');
  url.searchParams.set('fit', 'max');
  url.searchParams.set('w', Math.min(width, maxWidth ?? 3840).toString());
  if (quality) {
    url.searchParams.set('q', quality.toString());
  }
  return url.href;
}
